module.exports = require("./../../_gen/openfl/sensors/Accelerometer");